<template>
  <div>
    <label style="display: flex; position: relative; align-items: center">
      <ml-input
        class="w-full h-full member-selector"
        :class="!readonly ? 'not-readlony-input' : ''"
        style="border-radius: 5px; background-color: #fff"
        :value="memberName"
        @click="handleClickInput"
        readonly
      />
      <vs-icon icon-pack="feather" icon="icon-user" style="padding-left: 6px; padding-right: 6px; position: absolute; top: auto; right: 0; bottom: auto; font-size: 24px; border-left: 1px solid #cdcdcd"></vs-icon>
    </label>
    <popup-search-member v-if="popupType === 'member'" v-model="showPopup" :selectId="value || 0" @handleClickSelect="handleClickSelect" />
    <popup-search-user v-if="popupType === 'user'" v-model="showPopup" :selectId="value || 0" :disabledUserIds="disabledUserIds" @handleClickSelect="handleClickSelect" />
  </div>
</template>

<script>
import PopupSearchMember from "@/popup/PopupSearchMember";
import PopupSearchUser from "@/popup/PopupSearchUser.vue";

export default {
  name: "MemberSelector",
  components: { PopupSearchUser, PopupSearchMember },
  props: {
    value: [Number, String],
    readonly: Boolean,
    memberName: String,
    popupType: {
      type: String,
      default: "member",
    },
    disabledItems: {
      type: Array,
      default: () => [],
    },
    disabledUserIds: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    value(data) {
      this.value = data;
    },
  },
  data() {
    return {
      showPopup: false,
    };
  },

  methods: {
    handleClickInput() {
      if (!this.readonly) {
        this.showPopup = true;
      }
    },

    handleClickSelect(member) {
      this.$emit("input", member.id);
      this.$emit("select", member);
    },
  },
};
</script>

<style>
.member-selector input[readonly="readonly"] {
  background-color: #fff;
}
</style>

<style lang="scss" scoped>
.not-readlony-input::v-deep {
  input {
    background: white !important;
    cursor: pointer !important;
  }
}
</style>
